<template>
  <div>
    <!-- <v-row> -->
      <!-- <v-col cols="12" xs="12" sm="12" md="12" :class="classPadding" v-if="orgLevel == 'PL'"> -->
        <payroll-location
          :class-padding="classPadding"
          :title="'Payroll Locations'"
          :label="'Payroll Location'"
          v-model="selectedItem"
          :code-value="false"
          v-if="orgLevel == 'PL'"
        ></payroll-location>
      <!-- </v-col> -->
      <!-- <v-col cols="12" xs="12" sm="12" md="12" :class="classPadding" v-if="orgLevel == 'TK'"> -->
        <tk-group
          :class-padding="classPadding"
          :title="'Timekeep Group'"
          :label="'Timekeep Group'"
          v-model="selectedItem"
          :code-value="false"
          v-if="orgLevel == 'TK'"
        ></tk-group>
      <!-- </v-col> -->

      <!-- <v-col cols="12" xs="12" sm="12" md="12" :class="classPadding" v-if="orgLevel == 'PC'"> -->
        <project-code
          :class-padding="classPadding"
          :title="'Project Code'"
          :label="'Project Code'"
          v-model="selectedItem"
          :code-value="false"
          v-if="orgLevel == 'PC'"
        ></project-code>
      <!-- </v-col> -->
      
      <!-- <v-col cols="12" xs="12" sm="12" md="12" :class="classPadding" v-if="orgLevel == 'DEP'"> -->
        <department
          :class-padding="classPadding"
          :title="'Department'"
          :label="'Department'"
          v-model="selectedItem"
          :code-value="false"
          v-if="orgLevel == 'DEP'"
        ></department>
      <!-- </v-col> -->

      <!-- <v-col cols="12" xs="12" sm="12" md="12" :class="classPadding" v-if="orgLevel == 'DIV'"> -->
        <division
          :class-padding="classPadding"
          :title="'Division'"
          :label="'Division'"
          v-model="selectedItem"
          :code-value="false"
          v-if="orgLevel == 'DIV'"
        ></division>
      <!-- </v-col> -->

      <!-- <v-col cols="12" xs="12" sm="12" md="12" :class="classPadding" v-if="orgLevel == 'BRA'"> -->
        <branch
          :class-padding="classPadding"
          :title="'Branch'"
          :label="'Branch'"
          v-model="selectedItem"
          :code-value="false"
          v-if="orgLevel == 'BRA'"
        ></branch>
      <!-- </v-col> -->

      <!-- <v-col cols="12" xs="12" sm="12" md="12" :class="classPadding" v-if="orgLevel == 'SEC'"> -->
        <section-lookup
          :class-padding="classPadding"
          :title="'Section'"
          :label="'Section'"
          v-model="selectedItem"
          :code-value="false"
          v-if="orgLevel == 'SEC'"
        ></section-lookup>
      <!-- </v-col> -->
    <!-- </v-row> -->
    <designation
      :class-padding="classPadding"
      :title="'Designation'"
      :label="'Designation'"
      v-model="selectedItem"
      :code-value="false"
      v-if="orgLevel == 'DES'"
    ></designation>
    
    <unit
      :class-padding="classPadding"
      :title="'Unit'"
      :label="'Unit'"
      v-model="selectedItem"
      :code-value="false"
      v-if="orgLevel == 'UNIT'"
    ></unit>

    <area-lookup
      :class-padding="classPadding"
      :title="'Area'"
      :label="'Area'"
      v-model="selectedItem"
      :code-value="false"
      v-if="orgLevel == 'AREA'"
    ></area-lookup>

    <location
      :class-padding="classPadding"
      :title="'Location'"
      :label="'Location'"
      v-model="selectedItem"
      :code-value="false"
      v-if="orgLevel == 'LOC'"
    ></location>

    <emp-category
      :class-padding="classPadding"
      :title="'Employee Category'"
      :label="'Employee Category'"
      v-model="selectedItem"
      :code-value="false"
      v-if="orgLevel == 'EC'"
    ></emp-category>

    <rank
      :class-padding="classPadding"
      :title="'Rank'"
      :label="'Rank'"
      v-model="selectedItem"
      :code-value="false"
      v-if="orgLevel == 'RANK'"
    ></rank>

    <group
      :class-padding="classPadding"
      :title="'Group'"
      :label="'Group'"
      v-model="selectedItem"
      :code-value="false"
      v-if="orgLevel == 'GRP'"
    ></group>

    <pay-house
      :class-padding="classPadding"
      :title="'Pay House'"
      :label="'Pay House'"
      v-model="selectedItem"
      :code-value="false"
      v-if="orgLevel == 'PH'"
    ></pay-house>

    <emp-status
      :class-padding="classPadding"
      :title="'Employee Status'"
      :label="'Employee Status'"
      v-model="selectedItem"
      :code-value="false"
      v-if="orgLevel == 'ES'"
    ></emp-status>

    <tax-code
      :class-padding="classPadding"
      :title="'Tax'"
      :label="'Tax'"
      v-model="selectedItem"
      :code-value="false"
      v-if="orgLevel == 'TAX'"
    ></tax-code>

    <salary-class
      :class-padding="classPadding"
      :title="'Salary Classification'"
      :label="'Salary Classification'"
      v-model="selectedItem"
      :code-value="false"
      v-if="orgLevel == 'SC'"
    ></salary-class>

    <region
      :class-padding="classPadding"
      :title="'Region'"
      :label="'Region'"
      v-model="selectedItem"
      :code-value="false"
      v-if="orgLevel == 'REG'"
    ></region>
  </div>
</template>
<script>
const PayrollLocation = () =>
  import("@/views/setup/general/payroll-location/Lookup");
const TkGroup = () => import("@/views/others/TKGroupLookup");
const ProjectCode = () =>
  import(
    "@/views/setup/employment-other-info/others/project-file/project-list/Lookup"
  );
const Department = () =>
  import("@/views/setup/employment-info/organizational-level/department/Lookup");
const Division = () =>
  import("@/views/setup/employment-info/organizational-level/division/Lookup");
const Branch = () =>
  import("@/views/setup/employment-info/organizational-level/branch/Lookup");
const Section = () =>
  import("@/views/setup/employment-info/organizational-level/section/Lookup");
const Designation = () =>
  import("@/views/setup/employment-info/employee-level/designation/Lookup");
const Unit = () =>
  import("@/views/setup/employment-info/organizational-level/unit/Lookup");
const AreaLookup = () =>
  import("@/views/setup/employment-info/organizational-level/area/Lookup");
const Location = () =>
  import("@/views/setup/employment-info/organizational-level/location/Lookup");
const EmpCategory = () =>
  import("@/views/setup/employment-info/employee-level/employee-category/Lookup");
const Rank = () =>
  import("@/views/setup/employment-info/employee-level/rank/Lookup");
const Group = () =>
  import("@/views/setup/employment-info/organizational-level/group/Lookup");
const PayHouse = () =>
  import("@/views/setup/employment-info/organizational-level/pay-house/Lookup");
const EmpStatus = () =>
  import("@/views/setup/employment-info/employee-level/employee-status/Lookup");
const TaxCode = () => import("@/views/setup/general/tax-status/Lookup");
const SalaryClass = () =>
  import(
    "@/views/setup/employment-info/employee-level/salary-classification/Lookup"
  );
const Region = () => import("@/views/setup/personal-information/region/Lookup");
import { isEmpty } from "lodash"
export default {
  props: [
    "orgLevel",
    "value",
    "level"
  ],
  data: () => ({
    classPadding: "my-0 py-0",
    model: {},
    selectedItem: {}
  }),
  components: {
    PayrollLocation,
    ProjectCode,
    Department,
    Division,
    Branch,
    SectionLookup: Section,
    Designation,
    Unit,
    AreaLookup,
    Location,
    EmpCategory,
    Rank,
    Group,
    PayHouse,
    EmpStatus,
    TaxCode,
    SalaryClass,
    Region,
    TkGroup
  },
  watch: {
    selectedItem(val) {
      // if(isEmpty(val)){
      //   console.log(val)
      //   this.$emit("input", null)
      // }else {
      //   this.$emit("input", {
      //     code: val.code,
      //     desc: val.desc
      //   })
      // }
      this.$emit("input", val)
    }
  }
}
</script>